/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
export const usePaymentStore = defineStore("paymentStore", {
  state: () => ({
    paymentsList: {},
    alerts: {},
    params: {}
  }),
  getters: {
    paymentsTotalPages: state => Math.ceil(state.paymentsList.pagination?.total / state.paymentsList.perPage)
  },
  actions: {
    async listPayments() {
      const {
        startDate,
        endDate
      } = this.params.period;
      this.paymentDefaultFilterState();
      const query = {
        startDate: startDate ? startDate.toNetworkDate() : null,
        endDate: endDate ? endDate.toNetworkDate() : null,
        ...this.params
      };
      try {
        const response = await axios({
          url: "/payments",
          params: query
        });
        this.paymentsList.pagination = response.data.pagination;
        this.paymentsList.payments = response.data.payments?.map(p => ({
          id: p.id,
          date: new Date(p.date),
          invoices: p.invoices.map(ip => ip.invoice),
          amount: p.credits || p.amount,
          accounting: p.accounting,
          distributionPayments: p.distributionPayments,
          distribution: p.distribution,
          saving: false,
          status: p.status
        }));
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    reloadPaymentParms() {
      this.params = {
        search: '',
        limit: 20,
        offset: 0,
        orderby: "date",
        order: "desc",
        paymentStatus: "notindistribution",
        period: {
          startDate: new Date(new Date().getFullYear(), 0, 1),
          endDate: new Date(new Date().getFullYear(), 11, 31)
        }
      };
      this.paymentsList = {
        payments: [],
        pagination: {},
        perPage: 20,
        currentPage: 1
      };
    },
    async searchPayments(params) {
      this.params.search = params;
      let timeout = null;
      clearTimeout(timeout);
      timeout = setTimeout(async () => {
        this.listPayments();
      }, 500);
    },
    paymentSort(s) {
      if (s === this.params.orderby) {
        this.params.order = this.params.order === "asc" ? "desc" : "asc";
      }
      this.params.orderby = s;
      this.listPayments();
    },
    onPaymentsPageChange(page, perPage) {
      this.params.limit = perPage;
      this.paymentsList.currentPage = page;
      this.params.offset = (this.paymentsList.currentPage - 1) * perPage;
      this.paymentsList.perPage = perPage;
      this.listPayments();
    },
    async updatePayments({
      body
    }) {
      try {
        await axios({
          url: "/payments",
          method: "PUT",
          data: body
        });
        this.listPayments();
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async updatePayment({
      id,
      body
    }) {
      try {
        await axios({
          url: "/payments",
          method: "PUT",
          data: body,
          params: {
            id
          }
        });
        this.alerts.success('Payment updated successfully');
        this.listPayments();
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async distributionPayments(body, method = "POST") {
      try {
        await axios({
          url: `/distributionPayments`,
          method,
          data: {
            distributionPayments: body
          }
        });
        this.showAssignDestributionModal = false;
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async deleteDistributionPayments(paymentIds) {
      try {
        await axios({
          url: `/distributionPayments/delete`,
          method: "PUT",
          data: {
            paymentIds
          }
        });
        this.alerts.success('Distribution removed from payment successfully');
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    updateFilterPayment(filters) {
      this.params.paymentStatus = filters.paymentStatus;
      this.params.period = filters.period;
      this.listPayments();
    },
    paymentDefaultFilterState() {
      const {
        startDate,
        endDate
      } = this.params.period;
      const {
        paymentStatus
      } = this.params;
      const alltime = startDate === null && endDate === null;
      this.paymentDefaultFilterChange = !(alltime && paymentStatus === 'all');
    }
  }
});